import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    firstName: z.string().min(2, "First Name is required"),
    lastName: z.string().min(0, "Last Name is required"),
    email: z.string().min(5, "Email is required"),
    status: z.string(),
});

const newUserResolver = zodResolver(schema)

export default newUserResolver